import React, { useState } from "react";

const EmailGenerator = () => {
  const [formData, setFormData] = useState({
    // Left Logo / Org
    orgLogo: "https://via.placeholder.com/90x45?text=Brain+Serve",
    orgName: "Brain Serve Groups",
    orgTagline: "Career & Education Solutions",

    // Right Logo / Program
    programLogo: "https://via.placeholder.com/90x45?text=OYS+Logo",
    programName: "Operation Yuva Sankalp",
    programTagline: "OYS • Career Platform",

    // Content
    salutation: "Dear Sir/Madam,",
    greeting: "Greetings from",
    boldGreetingOrg: "Brain Serve Groups.",
    bodyText: `We are pleased to introduce Operation Yuva Sankalp (OYS), an online career platform designed to bridge the gap between graduation and a successful career.

OYS provides students with career guidance, placement preparation, skill development, resume building, and access to job opportunities, helping them become industry-ready.

We would be grateful for an opportunity to visit your institution and present the OYS platform to your management and Training & Placement Cell. We believe it can serve as a valuable career support system for your students.

Kindly let us know a convenient date and time for an online or offline meeting.

Please find the attached OYS trailer and information kit for your reference.

We look forward to the opportunity to connect with you and introduce Operation Yuva Sankalp (OYS) to your institution.

Thank you for your time and consideration.`,

    // Sign-off
    closing: "Warm regards,",
    senderTeam: "Operation Yuva Sankalp (OYS) Team",
    senderOrg: "Brain Serve Groups",

    // Social Links & Headers
    socialHeading: "Connect With Operation Yuva Sankalp",
    socialSubheading: "Stay connected with us for career opportunities, student resources, events and updates.",
    youtubeUrl: "https://youtube.com/@OperationYuvaSankalp",
    instagramUrl: "https://instagram.com/OperationYuvaSankalp",
    facebookUrl: "https://facebook.com/OperationYuvaSankalp",
    twitterUrl: "https://x.com/YuvaSankalp",
    linkedinUrl: "https://linkedin.com/company/OperationYuvaSankalp",

    // Contact Details
    contactEmail: "contact@brainserve.in",
    contactPhone: "+91 98765 43210",

    // Footer
    footerTitle: "Operation Yuva Sankalp (OYS)",
    footerSubtitle: "A Career Support Initiative by Brain Serve Groups",
    copyrightText: "© 2026 Brain Serve Groups. All rights reserved.",
  });

  const [copied, setCopied] = useState(false);

  // Handle standard text inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Convert uploaded image file to Base64
  const handleFileUpload = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, [fieldName]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // High-res hosted icons for client support
  const socialIcons = {
    yt: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
    ig: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
    fb: "https://cdn-icons-png.flaticon.com/512/5968/5968764.png",
    x: "https://cdn-icons-png.flaticon.com/512/5969/5969020.png",
    li: "https://cdn-icons-png.flaticon.com/512/3536/3536505.png",
  };

  // Generate Email HTML
  const generateEmailHtml = () => {
    return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Email Template</title>
</head>
<body style="margin: 0; padding: 24px 0; background-color: #f1f5f9; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #1e293b; line-height: 1.6;">
  <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: #ffffff; border-radius: 4px; overflow: hidden; box-shadow: 0 4px 14px rgba(0,0,0,0.06); border: 1px solid #e2e8f0;">
    
    <tr>
      <td bgcolor="#f95a00" style="padding: 14px 18px; background-color: #f95a00;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td valign="middle" align="left" style="width: 50%;">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                  ${
                    formData.orgLogo
                      ? `<td valign="middle" style="padding-right: 10px;">
                          <table border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; border-radius: 3px; padding: 3px 6px;">
                            <tr>
                              <td>
                                <img src="${formData.orgLogo}" alt="Logo" style="display: block; max-height: 38px; max-width: 75px; width: auto; height: auto; border: 0;" />
                              </td>
                            </tr>
                          </table>
                        </td>`
                      : ""
                  }
                  <td valign="middle">
                    <div style="color: #ffffff; font-size: 14px; font-weight: 800; line-height: 1.2; letter-spacing: -0.2px;">${formData.orgName}</div>
                    <div style="color: #fff4ea; font-size: 10px; font-weight: 500; line-height: 1.2; margin-top: 3px;">${formData.orgTagline}</div>
                  </td>
                </tr>
              </table>
            </td>

            <td valign="middle" align="right" style="width: 50%;">
              <table border="0" cellspacing="0" cellpadding="0" align="right">
                <tr>
                  <td valign="middle" align="right" style="padding-right: 10px;">
                    <div style="color: #ffffff; font-size: 13.5px; font-weight: 800; line-height: 1.2; letter-spacing: -0.2px;">${formData.programName}</div>
                    <div style="color: #fff4ea; font-size: 10px; font-weight: 500; line-height: 1.2; margin-top: 3px;">${formData.programTagline}</div>
                  </td>
                  ${
                    formData.programLogo
                      ? `<td valign="middle">
                          <table border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; border-radius: 3px; padding: 3px 6px;">
                            <tr>
                              <td>
                                <img src="${formData.programLogo}" alt="Program Logo" style="display: block; max-height: 38px; max-width: 75px; width: auto; height: auto; border: 0;" />
                              </td>
                            </tr>
                          </table>
                        </td>`
                      : ""
                  }
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>

    <tr>
      <td style="padding: 30px 28px 20px 28px; font-size: 13.5px; color: #334155; line-height: 1.65;">
        <p style="margin: 0 0 16px 0; color: #1e293b;">${formData.salutation}</p>
        <p style="margin: 0 0 16px 0; color: #1e293b;">
          ${formData.greeting} <strong style="color: #0f172a;">${formData.boldGreetingOrg}</strong>
        </p>
        
        <div style="margin: 0 0 24px 0; white-space: pre-line; color: #334155;">
          ${formData.bodyText}
        </div>

        <div style="margin-top: 24px;">
          <p style="margin: 0 0 4px 0; color: #64748b; font-size: 13px;">${formData.closing}</p>
          <p style="margin: 0 0 2px 0; font-weight: bold; color: #0f172a; font-size: 14px;">${formData.senderTeam}</p>
          <p style="margin: 0; font-weight: bold; color: #f95a00; font-size: 13px;">${formData.senderOrg}</p>
        </div>
      </td>
    </tr>

    <tr>
      <td style="padding: 5px 28px;">
        <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 0;" />
      </td>
    </tr>

    <tr>
      <td align="center" style="padding: 16px 28px 10px 28px;">
        <p style="font-size: 14px; font-weight: 700; color: #0f172a; margin: 0 0 4px 0;">${formData.socialHeading}</p>
        <p style="font-size: 11px; color: #64748b; margin: 0 0 16px 0;">${formData.socialSubheading}</p>

        <table align="center" border="0" cellpadding="0" cellspacing="0">
          <tr>
            <td align="center" style="padding: 0 5px;">
              <a href="${formData.youtubeUrl}" target="_blank" style="text-decoration: none;">
                <img src="${socialIcons.yt}" alt="YouTube" width="28" height="28" style="display: block; border: 0;" />
              </a>
            </td>
            <td align="center" style="padding: 0 5px;">
              <a href="${formData.instagramUrl}" target="_blank" style="text-decoration: none;">
                <img src="${socialIcons.ig}" alt="Instagram" width="28" height="28" style="display: block; border: 0;" />
              </a>
            </td>
            <td align="center" style="padding: 0 5px;">
              <a href="${formData.facebookUrl}" target="_blank" style="text-decoration: none;">
                <img src="${socialIcons.fb}" alt="Facebook" width="28" height="28" style="display: block; border: 0;" />
              </a>
            </td>
            <td align="center" style="padding: 0 5px;">
              <a href="${formData.twitterUrl}" target="_blank" style="text-decoration: none;">
                <img src="${socialIcons.x}" alt="X" width="28" height="28" style="display: block; border: 0;" />
              </a>
            </td>
            <td align="center" style="padding: 0 5px;">
              <a href="${formData.linkedinUrl}" target="_blank" style="text-decoration: none;">
                <img src="${socialIcons.li}" alt="LinkedIn" width="28" height="28" style="display: block; border: 0;" />
              </a>
            </td>
          </tr>
        </table>

        <p style="font-size: 12px; color: #475569; margin: 18px 0 0 0;">
          <strong>Email:</strong> <a href="mailto:${formData.contactEmail}" style="color: #0284c7; text-decoration: none;">${formData.contactEmail}</a> 
          <span style="color: #cbd5e1; margin: 0 8px;">|</span> 
          <strong>Phone:</strong> <a href="tel:${formData.contactPhone}" style="color: #0284c7; text-decoration: none;">${formData.contactPhone}</a>
        </p>
      </td>
    </tr>

    <tr>
      <td bgcolor="#091a2f" style="background-color: #091a2f; padding: 22px 20px; text-align: center; margin-top: 15px;">
        <p style="color: #f95a00; font-size: 13px; font-weight: 700; margin: 0 0 3px 0;">${formData.footerTitle}</p>
        <p style="color: #cbd5e1; font-size: 10.5px; margin: 0 0 8px 0;">${formData.footerSubtitle}</p>
        <div style="width: 32px; height: 2px; background-color: #f95a00; margin: 0 auto 10px auto;"></div>
        <p style="color: #64748b; font-size: 9.5px; margin: 0;">${formData.copyrightText}</p>
      </td>
    </tr>

  </table>
</body>
</html>`;
  };

  const handleCopyCode = () => {
    const rawHtml = generateEmailHtml();
    navigator.clipboard.writeText(rawHtml).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div style={styles.page}>
      {/* Top Action Bar */}
      <header style={styles.topBar}>
        <div>
          <h2 style={{ margin: 0, fontSize: "20px", color: "#0f172a" }}>✉️ Email Template Builder</h2>
          <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#64748b" }}>
            Paste URLs or upload local images directly. Output is formatted for 1-click Gmail pasting.
          </p>
        </div>
        <button onClick={handleCopyCode} style={styles.copyBtn}>
          {copied ? "✓ Copied HTML Ready for Gmail!" : "📋 Copy HTML for Gmail"}
        </button>
      </header>

      <div style={styles.container}>
        {/* Left: Input Form Controls */}
        <div style={styles.formPanel}>
          {/* Header Logos & Titles */}
          <h4 style={styles.sectionHeader}>🏢 Header & Logos (URL or Local Upload)</h4>
          <div style={styles.row}>
            {/* Org Logo */}
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Left Logo (Organization)</label>
              <input
                type="text"
                name="orgLogo"
                value={formData.orgLogo}
                onChange={handleChange}
                placeholder="Paste Image URL"
                style={styles.input}
              />
              <div style={styles.fileUploadBox}>
                <span style={{ fontSize: "11px", color: "#64748b" }}>or upload:</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileUpload(e, "orgLogo")}
                  style={styles.fileInput}
                />
              </div>
            </div>

            {/* Program Logo */}
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Right Logo (Program)</label>
              <input
                type="text"
                name="programLogo"
                value={formData.programLogo}
                onChange={handleChange}
                placeholder="Paste Image URL"
                style={styles.input}
              />
              <div style={styles.fileUploadBox}>
                <span style={{ fontSize: "11px", color: "#64748b" }}>or upload:</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileUpload(e, "programLogo")}
                  style={styles.fileInput}
                />
              </div>
            </div>
          </div>

          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Organization Name</label>
              <input type="text" name="orgName" value={formData.orgName} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Program / Initiative Name</label>
              <input type="text" name="programName" value={formData.programName} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Org Subtitle</label>
              <input type="text" name="orgTagline" value={formData.orgTagline} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Program Subtitle</label>
              <input type="text" name="programTagline" value={formData.programTagline} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          {/* Body Content */}
          <h4 style={styles.sectionHeader}>📝 Message Content</h4>
          <label style={styles.label}>Salutation</label>
          <input type="text" name="salutation" value={formData.salutation} onChange={handleChange} style={styles.input} />

          <label style={styles.label}>Opening Line</label>
          <div style={styles.row}>
            <input type="text" name="greeting" value={formData.greeting} onChange={handleChange} style={{ ...styles.input, flex: 1 }} />
            <input type="text" name="boldGreetingOrg" value={formData.boldGreetingOrg} onChange={handleChange} style={{ ...styles.input, flex: 1 }} />
          </div>

          {/* Large Body Content Field */}
          <label style={styles.label}>Email Body Content</label>
          <textarea
            name="bodyText"
            rows="14"
            value={formData.bodyText}
            onChange={handleChange}
            placeholder="Write your email body content here..."
            style={styles.largeTextarea}
          />

          {/* Sign-off */}
          <h4 style={styles.sectionHeader}>✍️ Sign-off</h4>
          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Closing Greeting</label>
              <input type="text" name="closing" value={formData.closing} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Sender Team</label>
              <input type="text" name="senderTeam" value={formData.senderTeam} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          {/* Social Media Link Inputs */}
          <h4 style={styles.sectionHeader}>🌐 Social Media Links & Channels</h4>
          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>YouTube URL</label>
              <input type="text" name="youtubeUrl" value={formData.youtubeUrl} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Instagram URL</label>
              <input type="text" name="instagramUrl" value={formData.instagramUrl} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Facebook URL</label>
              <input type="text" name="facebookUrl" value={formData.facebookUrl} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>X (Twitter) URL</label>
              <input type="text" name="twitterUrl" value={formData.twitterUrl} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          <div>
            <label style={styles.label}>LinkedIn URL</label>
            <input type="text" name="linkedinUrl" value={formData.linkedinUrl} onChange={handleChange} style={styles.input} />
          </div>

          {/* Contact Details */}
          <h4 style={styles.sectionHeader}>📞 Contact Info</h4>
          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Email Address</label>
              <input type="email" name="contactEmail" value={formData.contactEmail} onChange={handleChange} style={styles.input} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Phone Number</label>
              <input type="text" name="contactPhone" value={formData.contactPhone} onChange={handleChange} style={styles.input} />
            </div>
          </div>
        </div>

        {/* Right: Live Frame Preview */}
        <div style={styles.previewPanel}>
          <div style={styles.previewHeader}>
            <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>Live Visual Preview (Gmail View)</span>
          </div>
          <iframe title="Template Live Preview" srcDoc={generateEmailHtml()} style={styles.iframe} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    padding: "20px",
    boxSizing: "border-box",
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    backgroundColor: "#ffffff",
    padding: "14px 20px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
  },
  copyBtn: {
    backgroundColor: "#f97316",
    color: "#fff",
    border: "none",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: "bold",
    borderRadius: "6px",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(249, 90, 0, 0.25)",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "1.1fr 1fr",
    gap: "20px",
  },
  formPanel: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxHeight: "86vh",
    overflowY: "auto",
  },
  sectionHeader: {
    margin: "12px 0 4px 0",
    fontSize: "13.5px",
    color: "#0f172a",
    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "5px",
  },
  row: {
    display: "flex",
    gap: "10px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#64748b",
    marginBottom: "4px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "8px 10px",
    fontSize: "13px",
    borderRadius: "5px",
    border: "1px solid #cbd5e1",
    boxSizing: "border-box",
  },
  largeTextarea: {
    width: "100%",
    minHeight: "220px",
    padding: "10px",
    fontSize: "13.5px",
    lineHeight: "1.6",
    borderRadius: "5px",
    border: "1px solid #cbd5e1",
    boxSizing: "border-box",
    resize: "vertical",
    fontFamily: "inherit",
  },
  fileUploadBox: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginTop: "4px",
  },
  fileInput: {
    fontSize: "11px",
    color: "#475569",
  },
  previewPanel: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    maxHeight: "86vh",
  },
  previewHeader: {
    padding: "10px 16px",
    borderBottom: "1px solid #e2e8f0",
    backgroundColor: "#f8fafc",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    minHeight: "750px",
  },
};

export default EmailGenerator;